import {
    Button, TextField, Dialog, DialogTitle,
    DialogContent, DialogActions,
    Input, Avatar, CircularProgress, Box
} from "@mui/material";
import { useState } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from "../../firebaseconfig";

export const DepartmentDialog = ({
    openDepartmentDialog,
    handleCloseDepartmentDialog,
    handleSaveDepartment,
    setDepartmentDialogData,
    departmentDialogData,
}) => {
    const [imageUploading, setImageUploading] = useState(false);

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const storageRef = ref(storage, `departmentImages/${file.name}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    setImageUploading(true);
                },
                (error) => {
                    console.error('Error uploading image:', error);
                    setImageUploading(false);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        setDepartmentDialogData({
                            ...departmentDialogData,
                            image: downloadURL,
                        });
                        setImageUploading(false);
                    });
                }
            );
        }
    };

    return (
        <Dialog open={openDepartmentDialog} onClose={handleCloseDepartmentDialog} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{
                    backgroundColor: '#1976d2',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '1.25rem',
                }}
            >
                {departmentDialogData.id ? "Edit Department" : "Add Department"}
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: '#f5f5f5', padding: '20px' }}>
                <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    value={departmentDialogData.name}
                    onChange={(e) =>
                        setDepartmentDialogData({
                            ...departmentDialogData,
                            name: e.target.value,
                        })
                    }
                    sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <TextField
                    label="Description"
                    variant="outlined"
                    fullWidth
                    value={departmentDialogData.description}
                    onChange={(e) =>
                        setDepartmentDialogData({
                            ...departmentDialogData,
                            description: e.target.value,
                        })
                    }
                    sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <TextField
                    label="Author"
                    variant="outlined"
                    fullWidth
                    value={departmentDialogData.author}
                    onChange={(e) =>
                        setDepartmentDialogData({
                            ...departmentDialogData,
                            author: e.target.value,
                        })
                    }
                    sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <Input
                    type="file"
                    onChange={handleImageUpload}
                    sx={{ mb: 2 }}
                />
                {imageUploading ? (
                    <CircularProgress />
                ) : (
                    departmentDialogData.image && (
                        <Box sx={{ mb: 2 }}>
                            <Avatar
                                src={departmentDialogData.image}
                                alt={departmentDialogData.name}
                                sx={{ width: 56, height: 56 }}
                            />
                        </Box>
                    )
                )}
            </DialogContent>
            <DialogActions
                sx={{
                    padding: '16px',
                    backgroundColor: '#f5f5f5',
                    borderTop: '1px solid #ddd',
                }}
            >
                <Button onClick={handleCloseDepartmentDialog} color="secondary">
                    Cancel
                </Button>
                <Button
                    onClick={handleSaveDepartment}
                    variant="contained"
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};
